import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PermissionsService} from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-org-user-role',
  templateUrl: './org-user-role.component.pug',
  styleUrls: ['./org-user-role.component.scss'],
  standalone: false
})
export class OrgUserRoleComponent implements OnInit {

  @Input() role!: string;
  @Input() setToOwner = true;
  @Output() roleSelected = new EventEmitter();
  selectedRole = '';
  currentUserRole = '';
  roles = ['owner', 'admin', 'member', 'member (restricted)', 'billing', 'support']
  roleDisableStatus = [false, false, false, false, false, false]

  constructor(private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.currentUserRole = this.permissions.userRole;
    if (this.currentUserRole !== this.roles.slice(-1)[0]) {
      this.selectedRole = this.currentUserRole;
      this.roles.every((role, index) => {
        if (role === this.currentUserRole) {
          return false;
        }
        this.roleDisableStatus[index] = true;
        return true;
      })
    } else {
      this.selectedRole = this.roles[0];
    }
    if (this.role) this.selectedRole = this.role;
    this.roleClick(this.selectedRole)
  }

  roleClick(selectedRole: any) {
    this.selectedRole = selectedRole;
    this.roleSelected.emit(this.selectedRole)
  }
}
